import { context } from "../../wr-context";
import { makeAction, WorkflowUnit } from "../workflow";
import { isPathMatch } from "./utils";
export var PHASE_CONFIGURATION_KEY = "phasesConfiguration";
export var redirectToPhaseConfiguration = makeAction("redirectToPhaseConfiguration", function(next) {
    var ref;
    var arePhasesEnabled = Boolean((ref = context.state.companySettings) === null || ref === void 0 ? void 0 : ref.canAccessPhases);
    var cart = context.state.cart;
    var phaseConfigurableItemsExist = cart.some(function(product) {
        return product.rows.some(function(row) {
            return row.rowType === "component:phase";
        });
    });
    // Go to phase configuration only if there are items that have phase
    // configurations assigned to them AND that Phases are enabled for the
    // company
    if (phaseConfigurableItemsExist && arePhasesEnabled) {
        context.history.push(context.getRoutePath("phases"));
    } else {
        next();
    }
}, function() {
    return isPathMatch("phases");
});
export var defaultActions = [
    redirectToPhaseConfiguration
];
export var createPhaseConfigurationUnit = function(options) {
    var ref;
    var phaseConfigurationActions = (ref = options === null || options === void 0 ? void 0 : options.actions) !== null && ref !== void 0 ? ref : defaultActions;
    return new WorkflowUnit(PHASE_CONFIGURATION_KEY, phaseConfigurationActions);
};
var PhasesConfigurationUnit = createPhaseConfigurationUnit();
export default PhasesConfigurationUnit;
